import React, { useEffect, useState } from 'react'
import "./RelatedViewBook.css"
import { setting } from '../../Common/setting';
import Slider from 'react-slick';
import BookItem from '../BookItem/BookItem';
import { useSelector } from 'react-redux';


export default function RelatedViewBook({ book }) {
  
  const allCategories = useSelector(state => state.Books.categories)
  const allBooks = useSelector(state => state.Books.books)
  const {  categories } = book;
  console.log(allCategories, categories);

  const [relatedBooks,setRelatedBooks] = useState([]);


  
  const findRelatedBooks=()=>{
    //  To find books which falls under the categories of current books

    const tempRelated = new Set();

    // retrieving the categories ads from category ids
    // allCategories array consist of all categories and their corresponding ad ids
    const temp1  = allCategories.filter(o=> categories.some(i=> i._id === o._id));
    console.log("temp1",temp1);

    // storing all the books in set to avoid duplicate data
    for(let i=0;i<temp1.length;i++)
    {
      let categoryBooks = temp1[i].ads;

      for(let j=0;j<categoryBooks.length;j++)
      {
        tempRelated.add(categoryBooks[j]);
      }
    }
    var arr = Array.from(tempRelated);

    console.log("all boooks" ,allBooks)

    //  removing current book
    arr = arr.filter(id=>id!=book._id);
    console.log("book ids to find : ",arr);
    
    var  tempBooks  = allBooks.filter(o=> arr.some(id=> id=== o._id));
    console.log("final related books : ",tempBooks)

    setRelatedBooks(tempBooks);
    
  }

  useEffect(() => {
    
    findRelatedBooks();


  },[])
  
  return (
    <div className='RelatedViewBook'>
      <h2 >Related Books</h2>
      {(relatedBooks.length <=3)? 
        <div className='row'>
            {
                relatedBooks.map((element) => {
                
                return (

                <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                    <BookItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} categories={element.categories} id={element._id}/>
                </div>
                  
                )})
            }
        </div>:

        <Slider {...setting}>
        {
            relatedBooks.map((element) => {
                
                return (
                    <BookItem name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} id={element._id}/>
            )})
        }
        </Slider>
        }
    </div>
  )
}